import React, { useContext } from 'react';
import { PropsWithChildren } from 'react';
import { SignalRContext } from 'src';
import { useIdentity } from 'src/core/services/authentication';
import { AppConfiguration } from 'src/core/services/configuration.service';
import { AppConfig } from 'src/inversify.config';

export const NotificationsContext = ({ children }: PropsWithChildren) => {
  const identity = useIdentity();
  const config: AppConfiguration = useContext(AppConfig);

  return (
    <SignalRContext.Provider
      url={`${config.notificationsUrl}/api/hubs/notifications`}
      connectEnabled={identity?.accessToken !== undefined}
      accessTokenFactory={() => identity?.accessToken!}
      dependencies={[identity]}
    >
      {children}
    </SignalRContext.Provider>
  );
};
